import { SectionType } from '../enums/mediaTypes.ts';

export const isMovieTvOrSeason = (type: SectionType): type is SectionType.Movie | SectionType.Tv | SectionType.Season =>
  type === SectionType.Movie || type === SectionType.Tv || type === SectionType.Season;
